import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getAllDTGPlus } from 'actions/products';
import Tooltip from '@material-ui/core/Tooltip';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import EditDtgPlusDialog from 'pages/dtg-plus/EditDtgPlusDialog';
import Image from 'components/Image';
import {
  Container,
  ItemGroup,
  Item,
  ProductLink,
  ProductImage,
  Description,
  Text,
  Amount,
  DialogTitle,
} from 'styles/pages/browse-catalog/details.js';

const DtgPlus = () => {
  const [selectedDtgPlusProcess, setDtgPlusProcess] = useState(undefined);
  const [dtgPlusProducts, setDtgPlusProducts] = useState(undefined);
  const dispatch = useDispatch();

  useEffect(async () => {
    const request = await dispatch(getAllDTGPlus());

    if (request?.error) {
      return;
    }
    setDtgPlusProducts(request?.data);
  }, [dispatch, setDtgPlusProducts]);

  return (
    <div style={{ padding: 15 }}>
      <Container>
        <DialogTitle>
          Edit DTG Plus
          <Tooltip title='Add New Product'>
            <AddCircleIcon
              style={{
                float: 'right',
                cursor: 'pointer',
                color: '#000',
                marginTop: '5px',
                fontSize: 30,
              }}
              onClick={() => setDtgPlusProcess({})}
            />
          </Tooltip>
        </DialogTitle>

        <ItemGroup>
          {dtgPlusProducts?.map((item, index) => {
            return (
              <Item
                key={`productsCatalog${index}`}
                onClick={() => setDtgPlusProcess(item)}>
                <ProductLink>
                  <ProductImage>
                    <Image src={item?.MarketingImage} alt={item?.DisplayName} />
                  </ProductImage>
                  <Description>
                    <Text>{item?.DisplayName}</Text>
                  </Description>
                </ProductLink>
              </Item>
            );
          })}
        </ItemGroup>
      </Container>
      {selectedDtgPlusProcess && (
        <EditDtgPlusDialog
          open={!!selectedDtgPlusProcess}
          setModal={async (visibility, reload) => {
            setDtgPlusProcess(visibility);
            if (reload) {
              const request = await dispatch(getAllDTGPlus());

              if (request?.error) {
                return;
              }
              setDtgPlusProducts(request?.data);
            }
          }}
          dtgPlus={selectedDtgPlusProcess}
        />
      )}
    </div>
  );
};

export default DtgPlus;
